const resizeObserverErrors = new Set([
  'ResizeObserver loop completed with undelivered notifications.',
  'ResizeObserver loop limit exceeded',
])

export const esErrorResizeObserver = (message?: string) => {
  return typeof message === 'string' && resizeObserverErrors.has(message)
}

const ejecutarDespuesDePintar = (callback: () => void) => {
  if (globalThis.requestAnimationFrame === undefined) {
    globalThis.setTimeout(callback, 0)
    return
  }

  globalThis.requestAnimationFrame(callback)
}

export const estabilizarResizeObserver = () => {
  const ResizeObserverOriginal = globalThis.ResizeObserver

  if (ResizeObserverOriginal === undefined) return undefined

  globalThis.ResizeObserver = class ResizeObserverEstable extends ResizeObserverOriginal {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        ejecutarDespuesDePintar(() => {
          callback(entries, observer)
        })
      })
    }
  }

  return () => {
    globalThis.ResizeObserver = ResizeObserverOriginal
  }
}

export const ignorarErrorResizeObserver = () => {
  if (globalThis.window === undefined) return undefined

  const restaurarResizeObserver = estabilizarResizeObserver()

  const handleError = (event: ErrorEvent) => {
    if (!esErrorResizeObserver(event.message)) return

    event.preventDefault()
    event.stopImmediatePropagation()
  }

  globalThis.window.addEventListener('error', handleError, true)

  return () => {
    globalThis.window.removeEventListener('error', handleError, true)
    restaurarResizeObserver?.()
  }
}
